import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import {changeCurrentUser} from '../../state/actionCreators/index'
import withRouter from '../../utility/withRouter';
import apiInstance from '../apiInstance';

class Generate extends Component {
    constructor() {
        super();
        this.state = {
            businessName: '',
            businessApflUrl: '',
            businessEmail: '',
            businessPhone: '',
            businessAddress: '',
            businessLogo: '',
            inProgress: false,
            error: '',
            fieldErrors: {},
            learnMorePp: React.createRef(),
        };
    }

    handleGenerate = (e) => {
        e.preventDefault();

        this.setState((prevState) => {
            return ({
                ...prevState,
                inProgress: true,
                fieldErrors: {},
                error: ""
            })
        })

        var request_body = { 
            name: this.state.businessName,
            apflUrl: this.state.businessApflUrl,
            email: this.state.businessEmail,
            phone: this.state.businessPhone,
            address: this.state.businessAddress,
            logo: this.state.businessLogo
        };
        axios.post(process.env.REACT_APP_SERVER_URL + `/generate`, request_body)
            .then(async (response) => {

                if(!response.data?.user){
                    this.setState((prevState) => {
                        return ({
                            ...prevState,
                            inProgress: false,
                            error: 'Unable to generate website. You may already have created one.'
                        })
                    })
                    return;
                }

                localStorage.setItem('token', response.data?.user?.token);
                localStorage.setItem('userId', response.data?.user?._id)
                this.props.changeCurrentUser(response.data.user)

                const sid = response.data?.siteId;
                if (sid) {
                    try {
                        await apiInstance.put('/dashboard/claim', {
                            userId: response.data.user.id,
                            siteId: sid
                        });
                    } catch (err) {
                        console.error('Claim failed:', err.message);
                    }
                    window.location.href = '/websites';
                } else {
                    console.log('siteId is missing');
                    this.setState((prevState) => {
                        return ({
                            ...prevState,
                            inProgress: false,
                            error: 'Unable to generate website. You may already have created one.'
                        })
                    })
                }

            })
            .catch((error) => {
                console.log(error);
                if (error.response && (error.response.status == 400 && error.response.data?.fieldErrors)) {
                    this.setState((prevState) => {
                        return ({
                            ...prevState,
                            inProgress: false,
                            fieldErrors: error.response.data.fieldErrors
                        })
                    })
                }
                else {
                    this.setState((prevState) => {
                        return ({
                            ...prevState,
                            inProgress: false,
                            error: 'Something went wrong, please try again later'
                        })
                    })
                }
            });
    }

    handleInputChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        this.setState((prevState) => {
            return ({
                ...prevState,
                [name]: value
            })
        })
    }

    handleLearnMore = (e) => {
        this.state.learnMorePp.current.openPopup()
    }

    render() {
        let { businessName, businessApflUrl, businessEmail, businessPhone, businessAddress, businessLogo, inProgress, error, fieldErrors } = this.state;
        return (
            <div className="mjs-register-wrapper">
                <div className={`mjs-rg-container right-panel-active`} id="mjs-rg-container">
                    <div className={`mjs-rg-form-container mjs-rg-sign-up-container`}>
                        <form action="#">
                            <h4 className='mjs-gen-signup-hdng'>Fill the form below to generate your business website for free</h4>

                            <div className='mjs-register-usrname'><i className="fa-solid fa-user"></i><input
                                type="text"
                                placeholder="Business Name"
                                name="businessName"
                                value={businessName}
                                onChange={this.handleInputChange}
                            /></div>
                            {fieldErrors.businessName && <span className="mjs-error">{fieldErrors.businessName}</span>}

                            <div className='mjs-register-emailadrs'><i className="fa-solid fa-envelope"></i><input
                                type="email"
                                placeholder="Business Email"
                                name="businessEmail"
                                value={businessEmail}
                                onChange={this.handleInputChange}
                            /></div>
                            {fieldErrors.businessEmail && <span className="mjs-error">{fieldErrors.businessEmail}</span>}

                            <div className='mjs-register-usrname'><i className="fa-solid fa-phone"></i><input
                                type="text"
                                placeholder="Business Phone"
                                name="businessPhone"
                                value={businessPhone}
                                onChange={this.handleInputChange}
                            /></div>
                            {fieldErrors.businessPhone && <span className="mjs-error">{fieldErrors.businessPhone}</span>}

                            <div className='mjs-register-usrname'><i class="fa-solid fa-location-pin"></i><input
                                type="text"
                                placeholder="Business Address"
                                name="businessAddress"
                                value={businessAddress}
                                onChange={this.handleInputChange}
                            /></div>
                            {fieldErrors.businessAddress && <span className="mjs-error">{fieldErrors.businessAddress}</span>}

                            <div className='mjs-register-usrname'><i className="fa-solid fa-globe"></i><input
                                type="text"
                                placeholder="example.appfolio.com"
                                name="businessApflUrl"
                                value={businessApflUrl}
                                onChange={this.handleInputChange}
                            /></div>
                            {fieldErrors.businessApflUrl && <span className="mjs-error">{fieldErrors.businessApflUrl}</span>}

                            <button
                                onClick={this.handleGenerate}
                                disabled={ !businessName || !businessApflUrl || !businessEmail || !businessPhone || !businessAddress }
                            >
                                Generate Website
                            </button>

                            {(
                                inProgress &&
                                <p>
                                    <i className="fa-solid fa-spinner fa-spin"></i> Generating Your Website...
                                </p>
                            )}

                            <span className="mjs-error">{error}</span>
                            
                        </form>
                    </div>
                    <div className="mjs-rg-overlay-container">
                        <div className="mjs-rg-overlay">
                            <div className={`mjs-rg-overlay-panel mjs-rg-overlay-left`}>
                                <h2>Welcome to StateFolio</h2>
                                <p>Generate your Business website with AI in seconds. Generate now to access your private dashboard and start managing your brand online.</p>
                                <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Generate Your Website</p>
                                <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Unlock your Dashboard</p>
                                <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Start Free</p>
                                <p><i class="mjs_text_light_blue fa-solid fa-check"></i> No Credit Card Required</p>

                                <div className="mjs-mt-5"><div className='mjs-btn' onClick={this.handleLearnMore}>Learn More</div></div>

                            </div>
                        </div>
                    </div>
                </div>

                <LearnMorePopup ref={this.state.learnMorePp}/>

            </div>
        );
    }
}

class LearnMorePopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayPopup: false
        };
    }

    openPopup = () => {
        this.setState({ displayPopup: true })
    }

    closePopup = () => {
        this.setState({ displayPopup: false })
    }

    render () {
        let {displayPopup} = this.state;
        const pricing_amount = process.env.REACT_APP_STRIPE_MONTHLY_PRICING;
        return (
            <div className={'mjs-popup' + (displayPopup ? '' : ' mjs-hidden')}>
                <div className="mjs-forgotpwd">
                    <h2>Generate Your Website & Start Getting More Leads Today</h2>
                    <span className="mjs-popup-close" onClick={this.closePopup}>
                        <i className="fa-solid fa-xmark"></i>
                    </span>
                    <div className='mjs-row mjs-text-left'>
                        <div className='mjs-col50'>

                            <h4>Why generate your own website</h4>

                            <p>Instead of forcing business owners to:</p>
                            <p><i class="mjs_text_error fa-solid fa-xmark"></i> Hire designers</p>
                            <p><i class="mjs_text_error fa-solid fa-xmark"></i> Wait weeks for development</p>
                            <p><i class="mjs_text_error fa-solid fa-xmark"></i> Pay thousands upfront</p>
                            <p><i class="mjs_text_error fa-solid fa-xmark"></i> Worry about hosting & security</p>
                            <p><i class="mjs_text_error fa-solid fa-xmark"></i> Deal with technical headaches</p>

                            <h5>We flipped the model:</h5>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Generate your website in seconds</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> We handle hosting, updates, and security</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Go live in minutes, not weeks</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> You only pay after you see it</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Zero risk. Zero setup. Immediate results.</p>

                        </div>

                        <div className='mjs-col50'>
                            <h4>Simple, Transparent Pricing</h4>

                            <p>Simple pricing. Zero guesswork.</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Start Free</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> ${pricing_amount} / Month after full activation</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> No setup or upfront fees</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> No long-term contracts</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> You can cancel anytime.</p>

                            <h5>Includes:</h5>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Website hosting with Professional Emails</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Lifetime updates & security</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Technical support</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Performance monitoring and SEO Optimization</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Backup & uptime protection</p>

                        </div>
                        
                    </div>

                    <p>Your competitors are already online. This ensures <strong>you don't fall behind</strong>.</p>
                    
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return (
        {
            user: state.currentUser,
        }
    )
}
const mapDispatchToProps = (dispatch) => {
    return (
      {
        changeCurrentUser: (user) => { dispatch(changeCurrentUser(user)) },
      }
    )
  }
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Generate));